import React from 'react'
import Study from './study-logic/study-logic'
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme/theme'; 

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Study />
    </ThemeProvider>
  );
}

export default App;